import { ApiShopperLandingPageLink } from '@storefronts/common-types'
import { useContext } from 'react'
import { OverrideContext } from '../context/overrideContext'
import { UserEventDataContext } from '../context/UserEventDataContextProvider'
import { ViddyLPContext } from '../context/viddyLPContext'
import { getCombinedProductHistoryAndLandingPageLinks } from './userEventTools'

export function useCombinedProductHistoryAndLandingPageLinks(
    onlyForInitialized: boolean = false,
): ApiShopperLandingPageLink[] {
    const { abandonmentStorefrontData, initialized } =
        useContext(UserEventDataContext)
    const { landingPage } = useContext(ViddyLPContext)
    const { linkContentOverride } = useContext(OverrideContext)

    const sections =
        linkContentOverride?.tabs.flatMap((tab) => tab.sections) ??
        landingPage.bodyContent?.tabs.flatMap((tab) => tab.sections) ??
        []

    if (onlyForInitialized && !initialized) {
        return []
    }

    return getCombinedProductHistoryAndLandingPageLinks(
        abandonmentStorefrontData,
        [
            ...landingPage.landingPageLinks,
            ...(landingPage.sectionLandingPageLinks ?? []),
        ],
        sections,
    )
}

export function useHasMultipleProducts(): boolean {
    const productHistory = useCombinedProductHistoryAndLandingPageLinks()
    return productHistory.length > 1
}
